import moment from "moment";


export const DisplayDate = ({date}:{date:string}) => {
    return <div>{moment(date).format("lll")}</div>;
};